import { render, staticRenderFns } from "./OfficialDocument.vue?vue&type=template&id=53627b58&"
import script from "./OfficialDocument.vue?vue&type=script&lang=js&"
export * from "./OfficialDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports